import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext, useSiteSelection } from "@context";
import { useCurrentData, useManagerData } from "@hooks";
import { CurrentGrid, DashBanner } from "@components";
import { ROLES } from "@constants/roles";
import DashBreadcrumb from "./DashBreadcrumb";
import "./dash.css";

const Current = () => {
    const { auth } = useContext(AuthContext);
    const { compCode, siteCode } = useSiteSelection();
    const isAdminOrR1 = auth?.role === ROLES.SUPER_ADMIN || auth?.roleId === 'R1';

    const params = compCode ? { compCode: compCode } : {};
    const { data, refetch } = useCurrentData(params);
    const { data: managerData } = useManagerData(compCode ? { compCode: compCode } : {});

    if (!compCode) {
        return <Navigate to={isAdminOrR1 ? "/dash/company" : "/dash/site"} replace />;
    }
    if (!siteCode) {
        return <Navigate to="/dash/site" replace />;
    }

    return (
        <>
            <DashBreadcrumb />

            <div className="contents-wrap">
                <DashBanner
                    title="중대재해 발생 가능 현황"
                    description="사업장별 위험 데이터를 분석하여 사고 발생 가능성이 높은 현장을 직관적으로 파악하고, 선제적으로 대응하기 위한 모니터링 화면입니다."
                />
                {data && (
                    <CurrentGrid
                        siteCodes={data.siteDTO}
                        roleList={data.roleList}
                        companyInfo={data.companyInfo}
                        data={data.gridData}
                        selectedSite={siteCode}
                        managerName={managerData?.managerName}
                        managerPhone={managerData?.managerPhone}
                    />
                )}
            </div>
        </>
    );
};

export { Current };
